import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlowbiteQuoteSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 25,
	viewBox: "0 0 33 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_7498_8489)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.5 0.5C3.43913 0.5 2.42172 0.921427 1.67157 1.67157C0.921427 2.42172 0.5 3.43913 0.5 4.5V10.5C0.5 11.5609 0.921427 12.5783 1.67157 13.3284C2.42172 14.0786 3.43913 14.5 4.5 14.5H10.5C10.5 16.0913 9.86786 17.6174 8.74264 18.7426C7.61742 19.8679 6.0913 20.5 4.5 20.5H2.5C1.96957 20.5 1.46086 20.7107 1.08579 21.0858C0.710714 21.4609 0.5 21.9696 0.5 22.5C0.5 23.0304 0.710714 23.5391 1.08579 23.9142C1.46086 24.2893 1.96957 24.5 2.5 24.5H4.5C7.15216 24.5 9.6957 23.4464 11.5711 21.5711C13.4464 19.6957 14.5 17.1522 14.5 14.5V4.5C14.5 3.43913 14.0786 2.42172 13.3284 1.67157C12.5783 0.921427 11.5609 0.5 10.5 0.5H4.5ZM22.5 0.5C21.4391 0.5 20.4217 0.921427 19.6716 1.67157C18.9214 2.42172 18.5 3.43913 18.5 4.5V10.5C18.5 11.5609 18.9214 12.5783 19.6716 13.3284C20.4217 14.0786 21.4391 14.5 22.5 14.5H28.5C28.5 16.0913 27.8679 17.6174 26.7426 18.7426C25.6174 19.8679 24.0913 20.5 22.5 20.5H20.5C19.9696 20.5 19.4609 20.7107 19.0858 21.0858C18.7107 21.4609 18.5 21.9696 18.5 22.5C18.5 23.0304 18.7107 23.5391 19.0858 23.9142C19.4609 24.2893 19.9696 24.5 20.5 24.5H22.5C25.1522 24.5 27.6957 23.4464 29.5711 21.5711C31.4464 19.6957 32.5 17.1522 32.5 14.5V4.5C32.5 3.43913 32.0786 2.42172 31.3284 1.67157C30.5783 0.921427 29.5609 0.5 28.5 0.5H22.5Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7498_8489",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 33,
			height: 25,
			fill: "white"
		})
	}) })]
});
export default SvgFlowbiteQuoteSolid;
